module.exports = __webpack_public_path__ + "img/108.26ae0e3d.png";